// @ts-nocheck
import DidiFood from '@experimental-components/IconsComponents/DidiFood';
import UberEats from '@experimental-components/IconsComponents/UberEats';
import ParrotConnect from '@experimental-components/IconsComponents/ParrotConnect';
import Rappi from '@experimental-components/IconsComponents/Rappi';
import MenuOrdering from '@experimental-components/IconsComponents/MenuOrdering';

import { providersTypes } from 'utils/reportsFilters';

const iconComponents = {
  [providersTypes.PARROT]: ParrotConnect,
  [providersTypes.UBER_EATS]: UberEats,
  [providersTypes.DIDI_FOOD]: DidiFood,
  [providersTypes.RAPPI]: Rappi,
  [providersTypes.ONLINE]: MenuOrdering,
};

interface Props {
  value: string;
  size?: number;
  idRef?: string | number;
}

function ChanelItem({ value, size = 32, idRef }: Props) {
  const IconComponent = iconComponents[value] ?? ParrotConnect;

  return <IconComponent idRef={idRef} size={size} />;
}

export default ChanelItem;
